import axios from "axios";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/provider";
import { exportToCSV } from "../mostlyUsed/mainComponents";
import sellLongCalculator from "../mostlyUsed/sellLongCalculator";

const countTerm = 500;

const SpecialSellData = ({}) => {
  const [proccessState, setProccessState] = useState(0);
  const [proccessText, setProccessText] = useState("");
  const { verifiedCodes } = useContext(UserContext);

  const getWebsiteProducts = async (page) => {
    const res = await axios({
      method: "get",
      url: `https://libertoe.ir/wp-json/wc/v3/products?per_page=100&page=${page}`,
      headers: {
        // "Cache-Control": "no-cache",
        // "Content-Type": "application/json",
        Authorization:
          "Basic Y2tfMjcyZTA3MTFmMTZhOGM0YTQwNzVlYTkzMTVkMTYyMWI0YWYxMmYwNjpjc184Y2I0ODVkZWViZmJhN2RjY2EwZDNiN2Q4NTcwNTE2YzYwYjI1ODdh",
      },
      // data: body,
      //params: JSON.stringify(args)
      //data: bodyPreparer(args)
    });
    console.log(res);
    return res;
  };

  const addImages = async (cleanedData) => {
    let allProducts = [];
    const res1 = await getWebsiteProducts(1);
    if (res1.status === 200) {
      allProducts.push(...res1.data);
      const res2 = await getWebsiteProducts(2);
      if (res2.status === 200) {
        allProducts.push(...res2.data);
        const res3 = await getWebsiteProducts(3);
        if (res3.status === 200) {
          allProducts.push(...res3.data);
        }
      }
    }
    for (let i of allProducts) {
      for(let g in cleanedData){
        if(cleanedData[g].Barcode === i.sku){
          cleanedData[g].image = i.images[0].src
        }
      }
    }
    console.log("site pros, ", cleanedData);
    return cleanedData
  };

  const cleanProductsData = (oldData) => {
    const newData = [];
    const rawData = [];

    for (let i in oldData) {
      if (
        verifiedCodes.includes(oldData[i].ProductCode?.substring(0, 2)) &&
        oldData[i].ProductCode.length === 11
      ) {
        const gender =
          oldData[i].ProductCode.substring(9, 11) >= 41
            ? "male"
            : oldData[i].ProductCode.substring(9, 11) <= 34
            ? "kid"
            : "female";
        const existingProduct = newData.find(
          (product) =>
            product.Barcode === oldData[i].ProductCode.substring(0, 9) &&
            product.gender === gender
        );
        if (existingProduct) {
          existingProduct.Decrease =
            existingProduct.Decrease + oldData[i].Decrease;
          existingProduct.Increase =
            existingProduct.Increase + oldData[i].Increase;
          existingProduct.Opening =
            existingProduct.Opening + oldData[i].Opening;
          existingProduct.Quantity =
            existingProduct.Quantity + oldData[i].Quantity;
        } else {
          const convertedData = {
            Name: oldData[i].Name,
            gender: gender,
            Barcode: oldData[i].ProductCode.substring(0, 9),
            Amount: oldData[i].Amount,
            Quantity: oldData[i].Quantity,
            Opening: oldData[i].Opening,
            Increase: oldData[i].Increase,
            Decrease: oldData[i].Decrease,
            normalSell: 0,
            discountSell: 0,
            buy: 0,
          };
          newData.push(convertedData);
        }
        rawData.push(oldData[i]);
      }
    }
    console.log("raw: ", rawData);

    return newData;
  };

  const GetAllSells = async (cleanedData) => {
    // const today = new Date();
    // const lastWeak = new Date(
    //   today.getFullYear(),
    //   today.getMonth(),
    //   today.getDate() - 30
    // );
    const today = new Date("2024/09/21");
    const lastWeak = new Date("2024/04/20");
    let skipCount = 0;
    let allProductsCount = 1;
    const takeAmount = 500;
    let allDatas = [];
    while (allDatas.length < allProductsCount) {
      const res = await axios.post(
        "https://api.hesabfa.com/v1/invoice/getinvoices",
        {
          apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
          loginToken:
            "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
          type: 0,
          queryInfo: {
            sortBy: "Date",
            sortDesc: true,
            take: takeAmount,
            skip: skipCount * takeAmount,
            filters: [
              {
                property: "Date",
                operator: ">=",
                value: lastWeak,
              },
              {
                property: "Date",
                operator: "<=",
                value: today,
              },
              {
                property: "Status",
                operator: "=",
                value: 1,
              },
            ],
          },
        }
      );
      allProductsCount = res.data.Result.FilteredCount;
      allDatas.push(...res.data.Result.List);
      skipCount = skipCount + 1;
    }
    for (let i in allDatas) {
      for (let item of allDatas[i].InvoiceItems) {
        const barcode = item.Item.Barcode;
        const rawCode = barcode.substring(0, 9);
        const gender =
          barcode.substring(9, 11) >= 41
            ? "male"
            : barcode.substring(9, 11) <= 34
            ? "kid"
            : "female";
        const existingProduct = cleanedData.find(
          (product) => product.Barcode === rawCode && product.gender === gender
        );
        if (existingProduct) {
          if(rawCode === "330001611" && gender === "male"){
            console.log("what the faz? ", allDatas[i], existingProduct);
            
          }
          if (item.Discount > 0) {
            existingProduct.discountSell =
              existingProduct.discountSell + item.Quantity;
          } else {
            existingProduct.normalSell =
              existingProduct.normalSell + item.Quantity;
          }
        }
      }
    }
    console.log(allDatas);
    console.log("clened: ", cleanedData);
    for(let i of cleanedData){
      if(i.Decrease !== (i.normalSell + i.discountSell)){
        console.log("conflict!!!!! ", i);
      }
    }
    return cleanedData;
  };

  const getAllBuys = async (cleanedData) => {
    // const today = new Date();
    // const lastWeak = new Date(
    //   today.getFullYear(),
    //   today.getMonth(),
    //   today.getDate() - 30
    // );
    const today = new Date("2024/09/21");
    const lastWeak = new Date("2024/04/20");
    let skipCount = 0;
    let allProductsCount = 1;
    const takeAmount = 500;
    let allDatas = [];
    while (allDatas.length < allProductsCount) {
      const res = await axios.post(
        "https://api.hesabfa.com/v1/invoice/getinvoices",
        {
          apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
          loginToken:
            "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
          type: 1,
          queryInfo: {
            sortBy: "Date",
            sortDesc: true,
            take: takeAmount,
            skip: skipCount * takeAmount,
            filters: [
              {
                property: "Date",
                operator: ">=",
                value: lastWeak,
              },
              {
                property: "Date",
                operator: "<=",
                value: today,
              },
            ],
          },
        }
      );
      allProductsCount = res.data.Result.FilteredCount;
      allDatas.push(...res.data.Result.List);
      skipCount = skipCount + 1;
    }
    console.log("buys", allDatas);
    for (let i in allDatas) {
      for (let item of allDatas[i].InvoiceItems) {
        const barcode = item.Item.Barcode;
        const rawCode = barcode.substring(0, 9);
        const gender =
          barcode.substring(9, 11) >= 41
            ? "male"
            : barcode.substring(9, 11) <= 34
            ? "kid"
            : "female";
        const existingProduct = cleanedData.find(
          (product) => product.Barcode === rawCode && product.gender === gender
        );
        if (existingProduct) {
          existingProduct.buy = existingProduct.buy + item.Quantity;
        }
      }
    }
    console.log("also buys: ", cleanedData);
    return cleanedData;
  };

  const getAllProducts = async (skip, type, year) => {
    const today = new Date("2024/09/21");
    const lastWeak = new Date("2024/04/21");
    console.log("today: ", today);
    console.log("last week: ", lastWeak);

    const res = await axios.post(
      "https://api.hesabfa.com/v1/report/inventory",
      {
        apiKey: "E62BNpYDHmn1K8JFNJG24jDSpTE9ktBP",
        loginToken:
          "3849304732a5e3cfd84a908ffd0b8c1c4e44c804df3692627b127d3f5638d3791105a1df1ddd2f00cb6bf2f36c3d3827",
        startDate: lastWeak,
        endDate: today,
      }
    );
    const cleanedData = cleanProductsData(res.data.Result);
    const sepratedSellData = await GetAllSells(cleanedData);
    console.log("sepratedSellData: ", sepratedSellData);
    const allBuys = await getAllBuys(sepratedSellData);
    const imageAdded = await addImages(allBuys);

    return imageAdded;
  };

  const formatData = (data) => {
    let formattedData = []
    for(let item of data){
      const formatObject = {
        "image": "",
        "name": item.Name,
        "gender": item.gender,
        "opening count": item.Opening,
        "production count": item.buy,
        "Quantity": item.Quantity,
        "normal sell": item.normalSell,
        "discount sell": item.discountSell,
        "normal sell percent": (item.Opening + item.buy) ? ((item.normalSell / (item.Opening + item.buy)) * 100) : 0,
        "discount sell percent": (item.Opening + item.buy) ? ((item.discountSell / (item.Opening + item.buy)) * 100) : 0,
        "image url": item.image
      }
      formattedData.push(formatObject)
    }
    return formattedData
  }

  const startAction = async () => {
    const allProducts = await getAllProducts();
    const formattedData = formatData(allProducts)
    const converted = []
    // for(let i of allProducts){
    //   converted.push(Object.values(i))
    // }
    exportToCSV(formattedData, null, "last 30 days report");
    setProccessState(100);
    setProccessText("انجام شد");
  };

  return (
    <div style={{ width: "100%", marginTop: 30 }}>
      <button
        style={{
          backgroundColor: "white",
          border: "solid 1px gray",
          padding: 10,
          borderRadius: 10,
          cursor: "pointer",
          fontSize: 15,
        }}
        onClick={startAction}
      >
        شروع ایجاد فایل
      </button>
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          marginTop: 20,
        }}
      >
        <div
          style={{
            width: "80%",
            height: 20,
            backgroundColor: "#dbdbdb",
            borderRadius: 15,
            display: "flex",
            justifyContent: "end",
          }}
        >
          <div
            style={{
              width: `${proccessState}%`,
              height: 20,
              backgroundColor: "#00a600",
              borderRadius: 15,
              transition: "all 2s ease-in-out",
            }}
          ></div>
        </div>
        <p>{proccessText}</p>
      </div>
    </div>
  );
};

export default SpecialSellData;
